import HowtoBot from "./howto-bot";

export default HowtoBot;
